define("preview-grid/components/share-plan-modal", ["exports", "@ember/component", "@ember/utils", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _utils, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/utils",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if @sharePlan}}
    <Shared::Modal @close={{action @closeModal}} as |modal|>
      <modal.card @portrait={{true}}>
        <modal.card-header>
          <p class="o--modalHeader__title">
            {{t "preview_grid.share_plan.title"}}
            <Shared::Link
              @href="https://help.later.com/hc/en-us/articles/360042743434-Share-your-Instagram-Content-Calendar"
              title={{t "shared_phrases.learn_more"}}
            >
              {{svg-jar "help" class="o--icon--md o--icon--light u--float--right"}}
            </Shared::Link>
          </p>
        </modal.card-header>
        <modal.card-body>
          {{#if @errorMessage}}
            <p class="u--text--danger">{{@errorMessage}}</p>
          {{else}}
            <p>
              {{t "preview_grid.share_plan.description"}}
            </p>
  
            {{#if this.isLoaded}}
              <div class="u--m__t__lg u--m__b__md">
                <Shared::Link
                  @href={{@sharePlan.planUrl}}
                  @text={{@sharePlan.planUrl}}
                  class="o--form__input--lg o--form__input--view u--m__b__0 u--noDeco"
                />
                <CopyButton @text={{@sharePlan.planUrl}} class="o--btn o--btn--lg o--btn--block o--btn--primary u--m__t">
                  {{t "preview_grid.share_plan.copy_link"}}
                </CopyButton>
              </div>
            {{else}}
              <div class="o--card u--m__b u--text--center">
                <div class="o--loading u--m__tb__lg" style="top:0"></div>
                <p class="u--text--light">
                  {{t "preview_grid.share_plan.loading_message"}}
                </p>
              </div>
            {{/if}}
            <p class="u--text--sm">
              {{t "preview_grid.share_plan.cannot_change"}}
            </p>
          {{/if}}
        </modal.card-body>
        <modal.card-footer>
          <button class="o--btn o--btn--outline u--float--right" type="button" {{on "click" @closeModal}}>
            {{t "shared_words.done"}}
          </button>
        </modal.card-footer>
      </modal.card>
    </Shared::Modal>
  {{/if}}
  */
  {
    "id": "KpQ0roH0",
    "block": "[[[41,[30,1],[[[1,\"  \"],[8,[39,1],null,[[\"@close\"],[[28,[37,2],[[30,0],[30,2]],null]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,3,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"preview_grid.share_plan.title\"],null]],[1,\"\\n          \"],[8,[39,4],[[16,\"title\",[28,[37,3],[\"shared_phrases.learn_more\"],null]]],[[\"@href\"],[\"https://help.later.com/hc/en-us/articles/360042743434-Share-your-Instagram-Content-Calendar\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,5],[\"help\"],[[\"class\"],[\"o--icon--md o--icon--light u--float--right\"]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,3,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,4],[[[1,\"          \"],[10,2],[14,0,\"u--text--danger\"],[12],[1,[30,4]],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"preview_grid.share_plan.description\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isLoaded\"]],[[[1,\"            \"],[10,0],[14,0,\"u--m__t__lg u--m__b__md\"],[12],[1,\"\\n              \"],[8,[39,4],[[24,0,\"o--form__input--lg o--form__input--view u--m__b__0 u--noDeco\"]],[[\"@href\",\"@text\"],[[30,1,[\"planUrl\"]],[30,1,[\"planUrl\"]]]],null],[1,\"\\n              \"],[8,[39,6],[[24,0,\"o--btn o--btn--lg o--btn--block o--btn--primary u--m__t\"]],[[\"@text\"],[[30,1,[\"planUrl\"]]]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.share_plan.copy_link\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,0],[14,0,\"o--card u--m__b u--text--center\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"o--loading u--m__tb__lg\"],[14,5,\"top:0\"],[12],[13],[1,\"\\n              \"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.share_plan.loading_message\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"          \"],[10,2],[14,0,\"u--text--sm\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"preview_grid.share_plan.cannot_change\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n      \"],[8,[30,3,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[11,\"button\"],[24,0,\"o--btn o--btn--outline u--float--right\"],[24,4,\"button\"],[4,[38,7],[\"click\",[30,2]],null],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"shared_words.done\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"]],[]],null]],[\"@sharePlan\",\"@closeModal\",\"modal\",\"@errorMessage\"],false,[\"if\",\"shared/modal\",\"action\",\"t\",\"shared/link\",\"svg-jar\",\"copy-button\",\"on\"]]",
    "moduleName": "preview-grid/components/share-plan-modal.hbs",
    "isStrictMode": false
  });
  class SharePlanModalComponent extends _component2.default {
    get isLoaded() {
      const {
        planUrl
      } = this.args.sharePlan;
      return !(0, _utils.isEmpty)(planUrl);
    }
  }
  _exports.default = SharePlanModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SharePlanModalComponent);
});